import { createAction } from '@reduxjs/toolkit';

export const fetchPinwheelEligibility = createAction(
    'backend/FETCH::PINWHEEL_ELIGIBILITY',
);
